/* tslint:disable */
/* eslint-disable */
// Generated using typescript-generator version 3.2.1263 on 2026-06-12 09:52:03.

export interface ApiKey {
    id: string;
    name: string;
    role: string;
    subId: string;
    orgId: string;
    siteId: string;
    lastSeenAt: number;
}

export interface DashboardConfig {
    id: string;
    name: string;
    lastModified: number;
    widgets: DashboardWidget[];
}

export interface DashboardWidget {
    id: string;
    type: string;
    x: number;
    y: number;
    w: number;
    h: number;
    config: DashboardWidgetConfig;
}

export interface DashboardWidgetConfig {
    deviceName: string;
    metric: string;
    topic: string;
    gaugeMin: number;
    gaugeMax: number;
}

export interface DeviceData {
    id: string;
    topic: string;
    subId: string;
    orgId: string;
    siteId: string;
    name: string;
    devProfileId: string;
    gwDevId: string;
    ioId: string;
    descr: string;
    expires: number;
    locLat: number;
    locLong: number;
    coils: string[];
    decoderConf: string;
    recfreq: number;
    config: string;
    online: boolean;
    lastSeenAt: number;
}

export interface DeviceProfile {
    id: string;
    name: string;
    ioId: string;
    vendor: string;
    version: string;
    configView: string;
    decoder: string;
    decoderConf: string;
    config: string;
    coilsCount: number;
}

export interface DevicesSummary {
    neverSeenCount: number;
    inactiveCount: number;
    activeCount: number;
}

export interface Gateway {
    id: string;
    name: string;
    description: string;
    topic: string;
    vendor: string;
    serverHost: string;
    serverKey: string;
    localHost: string;
    domain: string;
    cachePath: string;
    cacheVersion: string;
    lastSeenAt: number;
    online: boolean;
}

export interface InOut {
    id: string;
    type: string;
    subId: string;
    orgId: string;
    siteId: string;
    name: string;
    description: string;
    configView: string;
    config: string;
    lastSeenAt: number;
    online: boolean;
}

export interface LastMessage {
    devId: string;
    timest: number;
    values: { [index: string]: any };
    coils: boolean[];
    times: number[];
    coilUpdate: boolean[];
    hasUpdate: boolean[];
    downlinkTimest: number;
    lastCheckTime: number;
}

export interface LogItem {
    time: number;
    devId: string;
    data: string;
}

export interface MapProperties {
    tileserverUrl: string;
    mapAttribution: string;
}

export interface MetricResponse {
    expressions: string[];
    columnNames: string[];
    dataTypes: string[];
    timestamps: number[];
    values: number[][];
}

export interface MetricsRequest {
    topic: string;
    start: number;
    end: number;
    limit: number;
    aggregator: string;
    cols: string[];
    downsampling: string;
    desc: boolean;
}

export interface Site {
    id: string;
    name: string;
    topic: string;
    subId: string;
    orgId: string;
}

export interface UpJsonMessage {
    devId: string;
    topic: string;
    measurements: string[];
    timestamp: number;
    values: any[];
    timestamps: number[];
    multiValues: any[][];
}

export interface UserData {
    login: string;
    email: string;
    name: string;
    role: string;
    pass: string;
    subId: string;
    orgId: string;
    siteId: string;
    lastSeenAt: number;
}

export interface UserSession extends SecurityContext {
    userData: UserData;
    ip: string;
    token: string;
    touch: number;
    admin: boolean;
}

export interface ChartRequest {
    ds: string;
    from: number;
    to: number;
    lim: number;
    lastRecs: boolean;
    col: string;
    dateFormat: string;
}

export interface UpPass {
    login: string;
    pass: string;
}

export interface Principal {
    name: string;
}

export interface SecurityContext {
    secure: boolean;
    userPrincipal: Principal;
    authenticationScheme: string;
}

export interface LoginPostDTO {
    username: string;
    password: string;
}

export interface ZoneConfig {
    id: string;
    name: string;
    siteId: string;
    devId: string;
    zones: Zone[];
    millis: number;
    checkIntervalSecond: number;
    parallelAllowed: boolean;
    weekDays: boolean[];
    hours: boolean[];
    onTimeMinute: number;
    logEnabled: boolean;
    notifications: { [index: string]: string };
}

export interface SwitchOnOff {
    coil: number;
    on: boolean;
    devId: string;
}

export interface Zone {
    coil: number;
    zoneTriggers: ZoneTrigger[];
}

export interface ZoneTrigger {
    conditionType: number;
    devId: string;
    sensor: string;
    onVal: number;
    offVal: number;
    maxTimeSec: number;
}

export interface HttpClient<O> {

    request<R>(requestConfig: { method: string; url: string; queryParams?: any; data?: any; copyFn?: (data: R) => R; options?: O; }): RestResponse<R>;
}

export class RestApplicationClient<O> {

    constructor(protected httpClient: HttpClient<O>) {
    }

    /**
     * HTTP POST /admin/api
     * Java method: com.hisenic.server.rs.AdminRs.createApiKey
     */
    createApiKey(arg0: ApiKey, options?: O): RestResponse<any> {
        return this.httpClient.request({ method: "POST", url: uriEncoding`admin/api`, data: arg0, options: options });
    }

    /**
     * HTTP PUT /admin/api
     * Java method: com.hisenic.server.rs.AdminRs.updateApiKey
     */
    updateApiKey(arg0: ApiKey, options?: O): RestResponse<any> {
        return this.httpClient.request({ method: "PUT", url: uriEncoding`admin/api`, data: arg0, options: options });
    }

    /**
     * HTTP GET /admin/api-keys/{siteId}
     * Java method: com.hisenic.server.rs.AdminRs.getSiteApiKeys
     */
    getSiteApiKeys(siteId: string, options?: O): RestResponse<ApiKey[]> {
        return this.httpClient.request({ method: "GET", url: uriEncoding`admin/api-keys/${siteId}`, options: options });
    }

    /**
     * HTTP GET /admin/api/{id}
     * Java method: com.hisenic.server.rs.AdminRs.getApiKey
     */
    getApiKey(id: string, options?: O): RestResponse<any> {
        return this.httpClient.request({ method: "GET", url: uriEncoding`admin/api/${id}`, options: options });
    }

    /**
     * HTTP DELETE /admin/api/{id}
     * Java method: com.hisenic.server.rs.AdminRs.removeApiKey
     */
    removeApiKey(id: string, options?: O): RestResponse<any> {
        return this.httpClient.request({ method: "DELETE", url: uriEncoding`admin/api/${id}`, options: options });
    }

    /**
     * HTTP GET /admin/apis
     * Java method: com.hisenic.server.rs.AdminRs.getAllApikey
     */
    getAllApikey(options?: O): RestResponse<ApiKey[]> {
        return this.httpClient.request({ method: "GET", url: uriEncoding`admin/apis`, options: options });
    }

    /**
     * HTTP GET /admin/maps
     * Java method: com.hisenic.server.rs.AdminRs.getMapSettings
     */
    getMapSettings(options?: O): RestResponse<MapProperties> {
        return this.httpClient.request({ method: "GET", url: uriEncoding`admin/maps`, options: options });
    }

    /**
     * HTTP POST /admin/pass
     * Java method: com.hisenic.server.rs.AdminRs.updatePassword
     */
    updatePassword(arg0: UpPass, options?: O): RestResponse<any> {
        return this.httpClient.request({ method: "POST", url: uriEncoding`admin/pass`, data: arg0, options: options });
    }

    /**
     * HTTP POST /admin/site
     * Java method: com.hisenic.server.rs.AdminRs.createSite
     */
    createSite(arg0: Site, options?: O): RestResponse<any> {
        return this.httpClient.request({ method: "POST", url: uriEncoding`admin/site`, data: arg0, options: options });
    }

    /**
     * HTTP PUT /admin/site
     * Java method: com.hisenic.server.rs.AdminRs.updateSite
     */
    updateSite(arg0: Site, options?: O): RestResponse<any> {
        return this.httpClient.request({ method: "PUT", url: uriEncoding`admin/site`, data: arg0, options: options });
    }

    /**
     * HTTP GET /admin/site/{id}
     * Java method: com.hisenic.server.rs.AdminRs.getSite
     */
    getSite(id: string, options?: O): RestResponse<any> {
        return this.httpClient.request({ method: "GET", url: uriEncoding`admin/site/${id}`, options: options });
    }

    /**
     * HTTP DELETE /admin/site/{id}
     * Java method: com.hisenic.server.rs.AdminRs.removeSite
     */
    removeSite(id: string, options?: O): RestResponse<any> {
        return this.httpClient.request({ method: "DELETE", url: uriEncoding`admin/site/${id}`, options: options });
    }

    /**
     * HTTP GET /admin/sites
     * Java method: com.hisenic.server.rs.AdminRs.getAllSites
     */
    getAllSites(options?: O): RestResponse<Site[]> {
        return this.httpClient.request({ method: "GET", url: uriEncoding`admin/sites`, options: options });
    }

    /**
     * HTTP GET /admin/user/{login}
     * Java method: com.hisenic.server.rs.AdminRs.getUser
     */
    getUser(login: string, options?: O): RestResponse<any> {
        return this.httpClient.request({ method: "GET", url: uriEncoding`admin/user/${login}`, options: options });
    }

    /**
     * HTTP DELETE /admin/user/{login}
     * Java method: com.hisenic.server.rs.AdminRs.removeUser
     */
    removeUser(login: string, options?: O): RestResponse<any> {
        return this.httpClient.request({ method: "DELETE", url: uriEncoding`admin/user/${login}`, options: options });
    }

    /**
     * HTTP POST /admin/userData
     * Java method: com.hisenic.server.rs.AdminRs.createUser
     */
    createUser(arg0: UserData, options?: O): RestResponse<any> {
        return this.httpClient.request({ method: "POST", url: uriEncoding`admin/userData`, data: arg0, options: options });
    }

    /**
     * HTTP PUT /admin/userData
     * Java method: com.hisenic.server.rs.AdminRs.updateUser
     */
    updateUser(arg0: UserData, options?: O): RestResponse<any> {
        return this.httpClient.request({ method: "PUT", url: uriEncoding`admin/userData`, data: arg0, options: options });
    }

    /**
     * HTTP GET /admin/users
     * Java method: com.hisenic.server.rs.AdminRs.getAllUsers
     */
    getAllUsers(options?: O): RestResponse<UserData[]> {
        return this.httpClient.request({ method: "GET", url: uriEncoding`admin/users`, options: options });
    }

    /**
     * HTTP GET /admin/users/{siteId}
     * Java method: com.hisenic.server.rs.AdminRs.getSiteUsers
     */
    getSiteUsers(siteId: string, options?: O): RestResponse<UserData[]> {
        return this.httpClient.request({ method: "GET", url: uriEncoding`admin/users/${siteId}`, options: options });
    }

    /**
     * HTTP GET /auth/getusersess
     * Java method: com.hisenic.server.rs.AuthRs.getusersess
     */
    getusersess(options?: O): RestResponse<any> {
        return this.httpClient.request({ method: "GET", url: uriEncoding`auth/getusersess`, options: options });
    }

    /**
     * HTTP POST /auth/login
     * Java method: com.hisenic.server.rs.AuthRs.loginPost
     */
    loginPost(arg0: LoginPostDTO, options?: O): RestResponse<any> {
        return this.httpClient.request({ method: "POST", url: uriEncoding`auth/login`, data: arg0, options: options });
    }

    /**
     * HTTP GET /auth/logout
     * Java method: com.hisenic.server.rs.AuthRs.logOut
     */
    logOut(options?: O): RestResponse<any> {
        return this.httpClient.request({ method: "GET", url: uriEncoding`auth/logout`, options: options });
    }

    /**
     * HTTP GET /auth/ping
     * Java method: com.hisenic.server.rs.AuthRs.ping
     */
    ping(options?: O): RestResponse<any> {
        return this.httpClient.request({ method: "GET", url: uriEncoding`auth/ping`, options: options });
    }

    /**
     * HTTP GET /dashboard/all
     * Java method: com.hisenic.server.rs.DashboardRs.getAll
     */
    getAll(options?: O): RestResponse<any> {
        return this.httpClient.request({ method: "GET", url: uriEncoding`dashboard/all`, options: options });
    }

    /**
     * HTTP POST /dashboard/save
     * Java method: com.hisenic.server.rs.DashboardRs.save
     */
    save(arg0: DashboardConfig, options?: O): RestResponse<any> {
        return this.httpClient.request({ method: "POST", url: uriEncoding`dashboard/save`, data: arg0, options: options });
    }

    /**
     * HTTP DELETE /dashboard/{id}
     * Java method: com.hisenic.server.rs.DashboardRs.delete
     */
    delete(id: string, options?: O): RestResponse<any> {
        return this.httpClient.request({ method: "DELETE", url: uriEncoding`dashboard/${id}`, options: options });
    }

    /**
     * HTTP GET /dashboard/{id}
     * Java method: com.hisenic.server.rs.DashboardRs.getById
     */
    getById(id: string, options?: O): RestResponse<any> {
        return this.httpClient.request({ method: "GET", url: uriEncoding`dashboard/${id}`, options: options });
    }

    /**
     * HTTP POST /device
     * Java method: com.hisenic.server.rs.DeviceRs.createDevice
     */
    createDevice(arg0: DeviceData, options?: O): RestResponse<any> {
        return this.httpClient.request({ method: "POST", url: uriEncoding`device`, data: arg0, options: options });
    }

    /**
     * HTTP PUT /device
     * Java method: com.hisenic.server.rs.DeviceRs.updateDevice
     */
    updateDevice(arg0: DeviceData, options?: O): RestResponse<any> {
        return this.httpClient.request({ method: "PUT", url: uriEncoding`device`, data: arg0, options: options });
    }

    /**
     * HTTP POST /device-profile
     * Java method: com.hisenic.server.rs.DeviceProfileRs.createDeviceProfile
     */
    createDeviceProfile(arg0: DeviceProfile, options?: O): RestResponse<any> {
        return this.httpClient.request({ method: "POST", url: uriEncoding`device-profile`, data: arg0, options: options });
    }

    /**
     * HTTP PUT /device-profile
     * Java method: com.hisenic.server.rs.DeviceProfileRs.updateDeviceProfile
     */
    updateDeviceProfile(arg0: DeviceProfile, options?: O): RestResponse<any> {
        return this.httpClient.request({ method: "PUT", url: uriEncoding`device-profile`, data: arg0, options: options });
    }

    /**
     * HTTP GET /device-profile/all
     * Java method: com.hisenic.server.rs.DeviceProfileRs.getAllDeviceProfile
     */
    getAllDeviceProfile(options?: O): RestResponse<DeviceProfile[]> {
        return this.httpClient.request({ method: "GET", url: uriEncoding`device-profile/all`, options: options });
    }

    /**
     * HTTP GET /device-profile/{id}
     * Java method: com.hisenic.server.rs.DeviceProfileRs.getDeviceProfile
     */
    getDeviceProfile(id: string, options?: O): RestResponse<any> {
        return this.httpClient.request({ method: "GET", url: uriEncoding`device-profile/${id}`, options: options });
    }

    /**
     * HTTP DELETE /device-profile/{id}
     * Java method: com.hisenic.server.rs.DeviceProfileRs.removeDeviceProfile
     */
    removeDeviceProfile(id: string, options?: O): RestResponse<any> {
        return this.httpClient.request({ method: "DELETE", url: uriEncoding`device-profile/${id}`, options: options });
    }

    /**
     * HTTP GET /device/all
     * Java method: com.hisenic.server.rs.DeviceRs.getAllDevices
     */
    getAllDevices(options?: O): RestResponse<DeviceData[]> {
        return this.httpClient.request({ method: "GET", url: uriEncoding`device/all`, options: options });
    }

    /**
     * HTTP GET /device/last-data/{id}
     * Java method: com.hisenic.server.rs.DeviceRs.getDeviceLastMetric
     */
    getDeviceLastMetric(id: string, options?: O): RestResponse<LastMessage> {
        return this.httpClient.request({ method: "GET", url: uriEncoding`device/last-data/${id}`, options: options });
    }

    /**
     * HTTP GET /device/logs/{dsId}/{limit}/{from}/{to}
     * Java method: com.hisenic.server.rs.DeviceRs.getDeviceLogs
     */
    getDeviceLogs(dsId: string, limit: number, from: number, to: number, options?: O): RestResponse<any> {
        return this.httpClient.request({ method: "GET", url: uriEncoding`device/logs/${dsId}/${limit}/${from}/${to}`, options: options });
    }

    /**
     * HTTP POST /device/metrics
     * Java method: com.hisenic.server.rs.DeviceRs.getMetrics
     */
    getMetrics(arg0: MetricsRequest, options?: O): RestResponse<any> {
        return this.httpClient.request({ method: "POST", url: uriEncoding`device/metrics`, data: arg0, options: options });
    }

    /**
     * HTTP POST /device/sendData/{id}/{port}
     * Java method: com.hisenic.server.rs.DeviceRs.postResponse
     */
    postResponse(id: string, port: number, arg2: string, options?: O): RestResponse<any> {
        return this.httpClient.request({ method: "POST", url: uriEncoding`device/sendData/${id}/${port}`, data: arg2, options: options });
    }

    /**
     * HTTP GET /device/site/{id}
     * Java method: com.hisenic.server.rs.DeviceRs.getSiteDevices
     */
    getSiteDevices(id: string, options?: O): RestResponse<DeviceData[]> {
        return this.httpClient.request({ method: "GET", url: uriEncoding`device/site/${id}`, options: options });
    }

    /**
     * HTTP GET /device/summary/{id}
     * Java method: com.hisenic.server.rs.DeviceRs.getDevicesSummary
     */
    getDevicesSummary(id: string, options?: O): RestResponse<DevicesSummary> {
        return this.httpClient.request({ method: "GET", url: uriEncoding`device/summary/${id}`, options: options });
    }

    /**
     * HTTP GET /device/{id}
     * Java method: com.hisenic.server.rs.DeviceRs.getDevice
     */
    getDevice(id: string, options?: O): RestResponse<DeviceData> {
        return this.httpClient.request({ method: "GET", url: uriEncoding`device/${id}`, options: options });
    }

    /**
     * HTTP DELETE /device/{id}
     * Java method: com.hisenic.server.rs.DeviceRs.removeDevice
     */
    removeDevice(id: string, options?: O): RestResponse<any> {
        return this.httpClient.request({ method: "DELETE", url: uriEncoding`device/${id}`, options: options });
    }

    /**
     * HTTP POST /gateway
     * Java method: com.hisenic.server.rs.GatewayRs.createGateway
     */
    createGateway(arg0: Gateway, options?: O): RestResponse<any> {
        return this.httpClient.request({ method: "POST", url: uriEncoding`gateway`, data: arg0, options: options });
    }

    /**
     * HTTP PUT /gateway
     * Java method: com.hisenic.server.rs.GatewayRs.updateGateway
     */
    updateGateway(arg0: Gateway, options?: O): RestResponse<any> {
        return this.httpClient.request({ method: "PUT", url: uriEncoding`gateway`, data: arg0, options: options });
    }

    /**
     * HTTP GET /gateway/all
     * Java method: com.hisenic.server.rs.GatewayRs.getAllGateway
     */
    getAllGateway(options?: O): RestResponse<Gateway[]> {
        return this.httpClient.request({ method: "GET", url: uriEncoding`gateway/all`, options: options });
    }

    /**
     * HTTP GET /gateway/{id}
     * Java method: com.hisenic.server.rs.GatewayRs.getGateway
     */
    getGateway(id: string, options?: O): RestResponse<any> {
        return this.httpClient.request({ method: "GET", url: uriEncoding`gateway/${id}`, options: options });
    }

    /**
     * HTTP DELETE /gateway/{id}
     * Java method: com.hisenic.server.rs.GatewayRs.removeGateway
     */
    removeGateway(id: string, options?: O): RestResponse<any> {
        return this.httpClient.request({ method: "DELETE", url: uriEncoding`gateway/${id}`, options: options });
    }

    /**
     * HTTP POST /io
     * Java method: com.hisenic.server.rs.InOutRs.createInOut
     */
    createInOut(arg0: InOut, options?: O): RestResponse<any> {
        return this.httpClient.request({ method: "POST", url: uriEncoding`io`, data: arg0, options: options });
    }

    /**
     * HTTP PUT /io
     * Java method: com.hisenic.server.rs.InOutRs.updateInOut
     */
    updateInOut(arg0: InOut, options?: O): RestResponse<any> {
        return this.httpClient.request({ method: "PUT", url: uriEncoding`io`, data: arg0, options: options });
    }

    /**
     * HTTP GET /io/all
     * Java method: com.hisenic.server.rs.InOutRs.getAllInOut
     */
    getAllInOut(options?: O): RestResponse<InOut[]> {
        return this.httpClient.request({ method: "GET", url: uriEncoding`io/all`, options: options });
    }

    /**
     * HTTP GET /io/{id}
     * Java method: com.hisenic.server.rs.InOutRs.getInOut
     */
    getInOut(id: string, options?: O): RestResponse<any> {
        return this.httpClient.request({ method: "GET", url: uriEncoding`io/${id}`, options: options });
    }

    /**
     * HTTP DELETE /io/{id}
     * Java method: com.hisenic.server.rs.InOutRs.removeInOut
     */
    removeInOut(id: string, options?: O): RestResponse<any> {
        return this.httpClient.request({ method: "DELETE", url: uriEncoding`io/${id}`, options: options });
    }

    /**
     * HTTP POST /metrics/chart
     * Java method: com.hisenic.server.rs.MetricsRs.geChart
     */
    geChart(arg0: ChartRequest, options?: O): RestResponse<any> {
        return this.httpClient.request({ method: "POST", url: uriEncoding`metrics/chart`, data: arg0, options: options });
    }

    /**
     * HTTP POST /metrics/csv
     * Java method: com.hisenic.server.rs.MetricsRs.getCsv
     */
    getCsv$POST$metrics_csv(arg0: ChartRequest, options?: O): RestResponse<any> {
        return this.httpClient.request({ method: "POST", url: uriEncoding`metrics/csv`, data: arg0, options: options });
    }

    /**
     * HTTP GET /metrics/getcsv/interval/{dsId}/{limit}/{from}/{to}
     * Java method: com.hisenic.server.rs.MetricsRs.getCsv
     */
    getCsv$GET$metrics_getcsv_interval_dsId_limit_from_to(dsId: string, limit: number, from: string, to: string, options?: O): RestResponse<any> {
        return this.httpClient.request({ method: "GET", url: uriEncoding`metrics/getcsv/interval/${dsId}/${limit}/${from}/${to}`, options: options });
    }

    /**
     * HTTP GET /metrics/getcsv/lastcnt/{dsId}/{limit}
     * Java method: com.hisenic.server.rs.MetricsRs.getLastCsv
     */
    getLastCsv(dsId: string, limit: number, options?: O): RestResponse<any> {
        return this.httpClient.request({ method: "GET", url: uriEncoding`metrics/getcsv/lastcnt/${dsId}/${limit}`, options: options });
    }

    /**
     * HTTP GET /metrics/getcsv/lastint/{dsId}/{seconds}
     * Java method: com.hisenic.server.rs.MetricsRs.getLastDurationCsv
     */
    getLastDurationCsv(dsId: string, seconds: string, options?: O): RestResponse<any> {
        return this.httpClient.request({ method: "GET", url: uriEncoding`metrics/getcsv/lastint/${dsId}/${seconds}`, options: options });
    }

    /**
     * HTTP POST /metrics/json
     * Java method: com.hisenic.server.rs.MetricsRs.getJson2
     */
    getJson2(arg0: ChartRequest, options?: O): RestResponse<any> {
        return this.httpClient.request({ method: "POST", url: uriEncoding`metrics/json`, data: arg0, options: options });
    }

    /**
     * HTTP GET /metrics/suggestCols
     * Java method: com.hisenic.server.rs.MetricsRs.suggestCols
     */
    suggestCols(queryParams?: { ds?: string; }, options?: O): RestResponse<string[]> {
        return this.httpClient.request({ method: "GET", url: uriEncoding`metrics/suggestCols`, queryParams: queryParams, options: options });
    }

    /**
     * HTTP GET /metrics/suggestDss
     * Java method: com.hisenic.server.rs.MetricsRs.suggestDss
     */
    suggestDss(options?: O): RestResponse<{ [index: string]: string }> {
        return this.httpClient.request({ method: "GET", url: uriEncoding`metrics/suggestDss`, options: options });
    }

    /**
     * HTTP POST /zone
     * Java method: com.hisenic.server.rs.ZoneConfigRs.createZoneConfig
     */
    createZoneConfig(arg0: ZoneConfig, options?: O): RestResponse<any> {
        return this.httpClient.request({ method: "POST", url: uriEncoding`zone`, data: arg0, options: options });
    }

    /**
     * HTTP PUT /zone
     * Java method: com.hisenic.server.rs.ZoneConfigRs.updateZoneConfig
     */
    updateZoneConfig(arg0: ZoneConfig, options?: O): RestResponse<any> {
        return this.httpClient.request({ method: "PUT", url: uriEncoding`zone`, data: arg0, options: options });
    }

    /**
     * HTTP GET /zone/all
     * Java method: com.hisenic.server.rs.ZoneConfigRs.getAllZoneConfig
     */
    getAllZoneConfig(options?: O): RestResponse<ZoneConfig[]> {
        return this.httpClient.request({ method: "GET", url: uriEncoding`zone/all`, options: options });
    }

    /**
     * HTTP GET /zone/site/{siteId}
     * Java method: com.hisenic.server.rs.ZoneConfigRs.getZoneConfigBySite
     */
    getZoneConfigBySite(siteId: string, options?: O): RestResponse<ZoneConfig[]> {
        return this.httpClient.request({ method: "GET", url: uriEncoding`zone/site/${siteId}`, options: options });
    }

    /**
     * HTTP POST /zone/switch
     * Java method: com.hisenic.server.rs.ZoneConfigRs.switchOnOff
     */
    switchOnOff(arg0: SwitchOnOff, options?: O): RestResponse<any> {
        return this.httpClient.request({ method: "POST", url: uriEncoding`zone/switch`, data: arg0, options: options });
    }

    /**
     * HTTP GET /zone/{id}
     * Java method: com.hisenic.server.rs.ZoneConfigRs.getZoneConfig
     */
    getZoneConfig(id: string, options?: O): RestResponse<any> {
        return this.httpClient.request({ method: "GET", url: uriEncoding`zone/${id}`, options: options });
    }

    /**
     * HTTP DELETE /zone/{id}
     * Java method: com.hisenic.server.rs.ZoneConfigRs.removeZoneConfig
     */
    removeZoneConfig(id: string, options?: O): RestResponse<any> {
        return this.httpClient.request({ method: "DELETE", url: uriEncoding`zone/${id}`, options: options });
    }
}

export type RestResponse<R> = Promise<Axios.GenericAxiosResponse<R>>;

function uriEncoding(template: TemplateStringsArray, ...substitutions: any[]): string {
    let result = "";
    for (let i = 0; i < substitutions.length; i++) {
        result += template[i];
        result += encodeURIComponent(substitutions[i]);
    }
    result += template[template.length - 1];
    return result;
}


// Added by 'AxiosClientExtension' extension

import axios from "axios";
import * as Axios from "axios";

declare module "axios" {
    export interface GenericAxiosResponse<R> extends Axios.AxiosResponse {
        data: R;
    }
}

class AxiosHttpClient implements HttpClient<Axios.AxiosRequestConfig> {

    constructor(private axios: Axios.AxiosInstance) {
    }

    request<R>(requestConfig: { method: string; url: string; queryParams?: any; data?: any; copyFn?: (data: R) => R; options?: Axios.AxiosRequestConfig; }): RestResponse<R> {
        function assign(target: any, source?: any) {
            if (source != undefined) {
                for (const key in source) {
                    if (source.hasOwnProperty(key)) {
                        target[key] = source[key];
                    }
                }
            }
            return target;
        }

        const config: Axios.AxiosRequestConfig = {};
        config.method = requestConfig.method as typeof config.method;  // `string` in axios 0.16.0, `Method` in axios 0.19.0
        config.url = requestConfig.url;
        config.params = requestConfig.queryParams;
        config.data = requestConfig.data;
        assign(config, requestConfig.options);
        const copyFn = requestConfig.copyFn;

        const axiosResponse = this.axios.request(config);
        return axiosResponse.then(axiosResponse => {
            if (copyFn && axiosResponse.data) {
                (axiosResponse as any).originalData = axiosResponse.data;
                axiosResponse.data = copyFn(axiosResponse.data);
            }
            return axiosResponse;
        });
    }
}

export class AxiosRestApplicationClient extends RestApplicationClient<Axios.AxiosRequestConfig> {

    constructor(baseURL: string, axiosInstance: Axios.AxiosInstance = axios.create()) {
        axiosInstance.defaults.baseURL = baseURL;
        super(new AxiosHttpClient(axiosInstance));
    }
}
